module.exports = __webpack_public_path__ + "img/icn_logo.f12eaa7a.svg";